module.exports = function() {
  return new Worker(__webpack_public_path__ + "cef8119bcfad15911723.worker.js");
};